import { client } from "../../infrastructure/graphql/client";
import { GET_VM_DISK_INFO } from "../../infrastructure/graphql/diskQueries";
import { getToken } from "../../infrastructure/storage/tokenStorage";

export class DiskService {
  async getVmDiskInfo(vmId) {
    try {
      const token = getToken();
      
      const result = await client.query({
        query: GET_VM_DISK_INFO,
        variables: { vmId },
        fetchPolicy: "network-only",
        context: {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        },
      });

      const response = result.data?.getVmDiskInfoById; 

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM disk info error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
}